import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { CADENCE_VERBOSE_STRING } from 'utils/subscriptions';
import WarningNote from '../WarningNote/WarningNote';
import styles from './YourOrderItem.module.css';

const YourOrderItem = ({
  id,
  imageUrl,
  name,
  quantity,
  inventoryLimit,
  price,
  variantDescriptors,
  updateQuantity,
  cadence,
}) => {
  const [updating, setUpdating] = useState(false);
  const itemDescriptors = variantDescriptors.map((varDesc) => {
    return varDesc.descriptor;
  });
  const displayWarningNote = quantity > inventoryLimit;
  const handleClickUpdate = () =>
    updateQuantity(id, quantity, inventoryLimit, setUpdating);

  return (
    <li className={styles.container}>
      <div className={styles.columns}>
        <div className={styles.column}>
          <img className={styles.img} src={imageUrl} alt={name} />
          <p className={styles.name}>
            {name}
            {cadence && ' Subscription'}
            {itemDescriptors.length > 0 && ` (${itemDescriptors.toString()})`}
            {cadence && (
              <span className={styles.cadence}>
                Ships every {CADENCE_VERBOSE_STRING[cadence]}
              </span>
            )}
          </p>
        </div>
        <div className={`${styles.column} ${styles.right}`}>
          <p className={styles.quantity}>{`x ${quantity}`}</p>
          <p className={styles.price}>{`$${Number(price).toFixed(2)}`}</p>
        </div>
      </div>
      {displayWarningNote && (
        <WarningNote
          inventoryLimit={inventoryLimit}
          disabledButton={updating}
          style={{ marginTop: 12 }}
          onClickButton={handleClickUpdate}
        />
      )}
    </li>
  );
};

YourOrderItem.propTypes = {
  id: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  inventoryLimit: PropTypes.number.isRequired,
  price: PropTypes.string.isRequired,
  variantDescriptors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateQuantity: PropTypes.func.isRequired,
  cadence: PropTypes.string,
};

YourOrderItem.defaultProps = {
  cadence: null,
};

export default YourOrderItem;
